module.exports = __webpack_public_path__ + "static/media/blog-blockchain-applied@2x.d492718a.jpg";